import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getCustomers = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/customers${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createCustomer = (data, token) =>
  axios.post(`${baseUrl}/customer`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteCustomer = (id, token) =>
  axios.delete(`${baseUrl}/customer/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updateCustomer = (id, data, token) =>
  axios.patch(`${baseUrl}/customer/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getCustomerById = (id, token) =>
  axios.get(`${baseUrl}/customer/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const getCustomerList = (token) =>
  axios.get(`${baseUrl}/customer-list`, {
    headers: {
      authorization: token,
    },
  });
